import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { ReactComponent as TrashCanIcon } from "images/trash-can.svg";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { cancelQuote } from "services";
import { CustomButton } from "ui";
import style from "./cancelQuoteBtn.module.css";

export const CancelQuoteButton = observer(({ id }: { id: string }) => {
  const { quotes, bidCard, actionModals } = useStores();

  const cancelQuoteHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Подтвердите отмену предложения котировки"
          successText="Котировка отменена"
          buttonText="Отменить котировку"
          cancelButtonText="Закрыть"
          calledQuery={() => cancelQuote({ id })}
          onSuccess={() => {
            setTimeout(() => {
              quotes.fetch();
              bidCard.updateCardById(bidCard.bid.id);
            }, 2000);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,

        onClose: () => actionModals.closeAll(),
      }
    );
  };
  return (
    <CustomButton
      icon={<TrashCanIcon style={{ width: 16, height: 16 }} />}
      onClick={cancelQuoteHandler}
      tooltip="Отменить предложение"
      className={`${style.cancelIcon} ${style.quoteCancelBtn}`}
      size="small"
      variant="outlined"
    />
  );
});
